import { render, staticRenderFns } from "./delete-client.vue?vue&type=template&id=42576e4a"
import script from "./delete-client.vue?vue&type=script&lang=js"
export * from "./delete-client.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports